/**
 * Current Ticketon miniapp host. The miniapp moved off the legacy
 * `https://ticketon.kz/miniapp/...` base onto its own subdomain, so this is
 * the single source of truth for links that open the Ticketon miniapp.
 */
export const TICKETON_MINIAPP_BASE_URL = 'https://miniapp.ticketon.kz';

/**
 * Rewrites a legacy Ticketon miniapp URL to the current host. Handles both the
 * bare `https://ticketon.kz` origin and the `https://ticketon.kz/miniapp`
 * prefix, dropping the now-redundant `/miniapp` path segment. URLs that are
 * already on the current host (or point elsewhere) are returned unchanged.
 */
export function normalizeTicketonMiniAppUrl(url: string): string {
  if (!url) {
    return url;
  }

  return url.replace(
    /^https?:\/\/(?:www\.)?ticketon\.kz(?:\/miniapp)?/i,
    TICKETON_MINIAPP_BASE_URL,
  );
}
